<script setup>
import { BigNumber, util } from 'greenwebjs';

const { amount, cat } = defineProps({
  amount: [BigNumber, Number],
  cat: Object,
});

const assetState = useState(`asset-${cat.tailHash}`);
if (!assetState.value) {
  const { assets } = await $fetch(`https://api.dexie.space/v1/assets?page_size=1&page=1&type=all&code=${cat.tailHash}`);
  assetState.value = assets[0];
}
</script>
<template>
  <NuxtLink target="_blank" :to="`https://dexie.space/assets/${cat.tailHash}`" class="inline-flex gap-1 items-center">
    <img class="h-6 w-6" :src="`https://icons.dexie.space/${cat.tailHash}.webp`" />{{ util.formatToken(amount) }}
    {{ assetState?.code || 'UNKNOWN' }}
  </NuxtLink>
</template>
